import { render } from "./WinnerList.vue?vue&type=template&id=1e5f49d6&scoped=true"
import script from "./WinnerList.vue?vue&type=script&lang=js"
export * from "./WinnerList.vue?vue&type=script&lang=js"

import "./WinnerList.vue?vue&type=style&index=0&id=1e5f49d6&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5f49d6"]])

export default __exports__